import { getCustomisationValue, updateCustomisationValue } from "../../../EditablePreview/EditablePreview";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";
import { changeNumericalFieldValue } from "../../ModuleList";

const PaddingModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    let paddingTopFieldConfig = null;
    let paddingRightFieldConfig = null;
    let paddingBottomFieldConfig = null;
    let paddingLeftFieldConfig = null;

    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('padding-top')) {
            paddingTopFieldConfig = field;
        } else if (field.field.includes('padding-right')) {
            paddingRightFieldConfig = field;
        } else if (field.field.includes('padding-bottom')) {
            paddingBottomFieldConfig = field;
        } else if (field.field.includes('padding-left')) {
            paddingLeftFieldConfig = field;
        }
    }

    const changePaddingFieldValue = (fieldId, value) => {
        let fieldConfig;
        switch (fieldId) {
            case 'padding-top':
                fieldConfig = paddingTopFieldConfig;
                break;
            case 'padding-right':
                fieldConfig = paddingRightFieldConfig;
                break;
            case 'padding-bottom':
                fieldConfig = paddingBottomFieldConfig;
                break;
            case 'padding-left':
                fieldConfig = paddingLeftFieldConfig;
                break;
            default:
                return;
        }

        if (fieldConfig?.dataLink) {
            if (changeNumericalFieldValue(customisationVars, fieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Padding</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-one-column'>
                
                <div className='v2-module-columns-holder'>
                    <div className='v2-module-one-column'>
                        <div className='v2-module-field-label'>Left</div>
                        <ModuleNumericalInput
                            // fieldLabel="Left"
                            value={getCustomisationValue(customisationVars, paddingLeftFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-'}
                            fieldId={'padding-left'}
                            enabled={!!paddingLeftFieldConfig?.dataLink}
                            onChange={(fieldId, value) => changePaddingFieldValue("padding-left", value)}
                            hiddenDropDown={true}
                            hiddenDropDownOptions={[0, 5, 10, 15, 20, 25, 30, 35, 40, 50]}
                        />
                    </div>
                    <div className='v2-module-one-column'>
                        <div className='v2-module-field-label'>Right</div>
                        <ModuleNumericalInput
                            // fieldLabel="Right"
                            value={getCustomisationValue(customisationVars, paddingRightFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-'}
                            fieldId={'padding-right'}
                            enabled={!!paddingRightFieldConfig?.dataLink}
                            onChange={(fieldId, value) => changePaddingFieldValue("padding-right", value)}
                            hiddenDropDown={true}
                            hiddenDropDownOptions={[0, 5, 10, 15, 20, 25, 30, 35, 40, 50]}
                        />
                    </div>
                </div>
                <div className='v2-module-columns-holder'>
                    <div className='v2-module-one-column'>
                        <div className='v2-module-field-label'>Top</div>
                        <ModuleNumericalInput
                            //fieldLabel="Top"
                            value={getCustomisationValue(customisationVars, paddingTopFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-'}
                            fieldId={'padding-top'}
                            enabled={!!paddingTopFieldConfig?.dataLink}
                            onChange={(fieldId, value) => changePaddingFieldValue("padding-top", value)}
                            hiddenDropDown={true}
                            hiddenDropDownOptions={[0, 5, 10, 15, 20, 25, 30, 35, 40, 50]}
                        />
                    </div>
                    <div className='v2-module-one-column'>
                        <div className='v2-module-field-label'>Bottom</div>
                        <ModuleNumericalInput
                            // fieldLabel="Bottom"
                            value={getCustomisationValue(customisationVars, paddingBottomFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-'}
                            fieldId={'padding-bottom'}
                            enabled={!!paddingBottomFieldConfig?.dataLink}
                            onChange={(fieldId, value) => changePaddingFieldValue("padding-bottom", value)}
                            hiddenDropDown={true}
                            hiddenDropDownOptions={[0, 5, 10, 15, 20, 25, 30, 35, 40, 50]}
                        />
                    </div>
                    
                </div>
            </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default PaddingModule;
